import PropTypes from 'prop-types';
import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';

/** Checked (incl. disabled) state uses success green — only when `variant="success"`. */
const SuccessVariantWrap = styled.span`
    display: inline-flex;
    align-items: flex-start;
    line-height: 1;
    & .ant-checkbox-checked .ant-checkbox-inner,
    & .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        background-color: #22c55e !important;
        border-color: #22c55e !important;
    }
    & .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: #fff !important;
    }
    & .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        opacity: 1 !important;
    }
    & .ant-checkbox-wrapper-disabled.ant-checkbox-wrapper-checked {
        opacity: 1;
    }
`;

/**
 * App Checkbox — wraps Ant Design Checkbox.
 * @param {boolean} [readOnly] — non-interactive (maps to `disabled` on the underlying control).
 * @param {'default'|'success'} [variant] — `success`: green styling when checked (e.g. deliverables done).
 * @param {Object} [style] — on wrapper when `variant="success"`, else on Ant Checkbox.
 * @param {string} [className] — same as `style`.
 * @param {Object} [rest] — passed through to Ant Design Checkbox (`checked`, `onChange`, etc.).
 */
export const Checkbox = ({ readOnly = false, variant = 'default', style, className, disabled, ...rest }) => {
    const mergedDisabled = Boolean(readOnly || disabled);

    if (variant === 'success') {
        return (
            <SuccessVariantWrap style={style} className={className}>
                <AntCheckbox {...rest} disabled={mergedDisabled} />
            </SuccessVariantWrap>
        );
    }

    return <AntCheckbox {...rest} disabled={mergedDisabled} style={style} className={className} />;
};

Checkbox.propTypes = {
    readOnly: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'success']),
    style: PropTypes.object,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};
